<template>
    <el-container class="layout-container">
      <el-aside width="220px" class="layout-aside">
        <!-- <a href="https://www.domidesk.com" target="_blank"><img src="@/assets/images/logo.png" alt="" srcset="" class="logo"></a> -->
        <a class="flex align-center"><img src="@/assets/images/logo.png" alt="" srcset="" class="logo"></a>
        <el-menu :default-active="activeMenu" mode="vertical" class="menu-wrap">
              <SidebarItem
                  v-for="(route, index) in routes"
                  :key="route.path  + index"
                  :item="route"
                  :base-path="route.path"
                  :activeMenu="activeMenu"
                  :totalUnread="totalUnread"
              />
        </el-menu>
        <!-- <UserInfo /> -->
      </el-aside>
  
      <el-container>
        <el-header class="layout-header">
          <img src="@/assets/images/complate-info.png" v-if="improveInfo.editState === 1" alt="" srcset="" class="complate-img" @click="infoVisible = true">
          <el-popover
            placement="bottom"
            width="280">
            <div style="padding:12px">
              <div class="flex align-center justify-between">
                <div class="user-info">
                  <div class="avatar">
                    <img :src="userInfo.avatar" alt="" srcset="" v-if="userInfo.avatar">
                    <el-image v-else :src="require('../assets/images/mine.png')" fit="fill"></el-image>
                    <!-- <i class="el-icon-s-custom icon" v-else></i> -->
                  </div>
                  <span>{{ userInfo.username }}</span>
                </div>
                <!-- <div>
                  <el-popover placement="bottom" width="100">
                    <div class="status-change">
                      <div class="row" v-for="(item,index) in userStatusList" :key="index" @click="changeStatus(item.dictValue)">
                        <p v-if="item.dictValue==1" class="status-online">{{item.dictLabel}}</p>
                        <p v-else-if="item.dictValue==2" class="status-busy">{{item.dictLabel}}</p>
                        <p v-else-if="item.dictValue==0" class="status-offline">{{item.dictLabel}}</p>
                        <svg v-if="selectStatus == item.dictValue" width="12" height="14" color="#1890FF"><use href="#check"></use></svg>
                      </div>
                      <p class="explain" @click="statusDialogVisible = true">状态说明</p>
                    </div>
                    <div slot="reference" class="status-box">
                      <span v-if="userInfo.state == 1" class="status-online">在线</span>
                      <span v-else-if="userInfo.state == 2" class="status-busy">忙碌</span>
                      <span v-else-if="userInfo.state == 0" class="status-offline">离线</span>
                      <span class="el-icon-arrow-right"></span>
                    </div>
                  </el-popover>
                </div> -->
              </div>
              <div class="popover-content">
                <!-- <router-link to="/user">
                  <p class="item">账号信息</p>
                </router-link>
                <el-popover
                trigger="hover"
                placement="right-start"
                width="96">
                  <div class="language-box">
                    <p class="item">简体中文</p>
                    <p class="item">繁体中文</p>
                  </div>
                  <p slot="reference" class="item">系统语言</p>  
                </el-popover>
                <p class="item"><a href="https://www.domidesk.com/download" target="_blank">多端下载</a></p>
                <p class="item" @click="toShare">推广返佣</p> -->
                <p class="item" @click="logout">退出登录</p>
              </div>
            </div>
            <div slot="reference" class="userbox">
              <div class="avatar">
                <img :src="userInfo.avatar" alt="" srcset="" v-if="userInfo.avatar">
                <el-image v-else :src="require('../assets/images/mine.png')" fit="fill"></el-image>
                <!-- <i class="el-icon-s-custom icon" v-else></i> -->
                
                <span v-if="userInfo.state == 1" class="online"></span>
                <span v-else-if="userInfo.state == 2" class="busy"></span>
                <span v-else-if="userInfo.state == 0" class="offline"></span>
              </div>
              <span v-if="userInfo.state == 1" class="status">在线</span>
              <span v-else-if="userInfo.state == 2" class="status">忙碌</span>
              <span v-else-if="userInfo.state == 0" class="status">离线</span>
              <span class="user-name">{{ userInfo.username }}</span>
              <i class="el-icon-caret-bottom"></i>
            </div>
          </el-popover>
        </el-header>
        <el-main>
          <router-view />
        </el-main>

        <el-dialog class="dialog-wrap" :visible="statusDialogVisible" title="状态说明" width="320px" center :show-close="false" :close-on-click-modal="false">
          <div class="flex flex-v">
            <p class="row"><span class="title">在线状态：</span>当前项目若开启【自动分配】会话功能，新会话将自动分配给当前为【在线】状态&未达到当日接待上限的成员账号</p>
            <p class="row"><span class="title">忙碌状态：</span>系统将不会自动分配新会话给当前为【忙碌】状态的成员账号，但可手动接入新会话，或继续处理未结束的会话</p>
            <p class="row"><span class="title">离线状态：</span>当对应成员账号退登后或手动切换为离线状态，将不再为其自动分配新会话，但可手动接入新会话，或继续处理未结束的会话</p>
          </div>
          <span slot="footer">
            <el-button @click="handleClose" size="small">关闭</el-button>
          </span>
        </el-dialog>
        <ComplateInfo :visible="infoVisible" 
          @update:visible="infoVisible = $event"
          @confirm="getImproveInfo"
          :info="improveInfo"/>
      </el-container>
    </el-container>
</template>
  
<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
// import UserInfo from "./userInfo.vue";
import ComplateInfo from "./complateInfo.vue";
import { dictList,userState,improveInfo } from '@/api/auth';
import { checkApply } from '@/api/invite';
export default {
    components: { SidebarItem, ComplateInfo },
    name: 'LayoutPage',
    computed: {
        ...mapGetters(['routes', 'userInfo', 'totalUnread']),
        activeMenu() {
            const route = this.$route;
            const { meta, path } = route;
            if (meta.activeMenu) {
                return meta.activeMenu;
            }
            return path;
        },
    },
    data() {
      return {
        userStatusList: [],
        selectStatus: 0,
        statusDialogVisible: false,
        infoVisible: false,
        improveInfo: {},
      };
    },
    created() {
      this.getStatusList();
      // this.getImproveInfo()
    },
    methods: {
      getImproveInfo() {
          improveInfo().then((res) => {
              this.improveInfo = res.data;
          }).catch(() => {})
      },
      toShare() {
        checkApply().then((res) => {
          if(res.data.state === 1) {
            this.$router.push('/partnershare/overview')
          }else{
            this.$router.push('/partnershare/apply')
          }
        }).catch(() => {})
      },
      async logout() {
        this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('LogOut').then(() => {
            location.href = '/login';
          }).catch(() => {});
        }).catch(() => {});
      },
      // 获取客服登录状态
      getStatusList(){
        dictList('member_config_state').then((res) => {
            this.userStatusList = res.data
            this.selectStatus = this.userInfo.state
        }).catch(()=> {})
      },
      changeStatus(value){
        this.selectStatus = value
        userState({
          state: value
        }).then((res) => {
          this.$store.dispatch('GetInfo');
          this.$refs.userInfoPopover.hide()
          this.$refs.statusPopover.hide()
        }).catch(()=> {})
      },

      handleClose(){
        this.statusDialogVisible = false
      },
    }
};
  </script>
  
  <style lang="scss" scoped>
  .layout-container {
    height: 100vh;
    .layout-aside{
      position: relative;
      z-index: 2;
      padding: 18px 12px;
      box-sizing: border-box;
      box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
      .aside-item{
        width: 100%;
        margin: 12px 0;
      }
      .logo{
        width: 150px;
        height: 46px;
      }
      .logo-txt{
        font-size: 16px;
        font-weight: bold;
        margin-left: 8px;
      }
      .menu-wrap{
        // height: calc(100vh - 243px);
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 0; 
      }
      }
    }
    .layout-header{
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      border-bottom: 1px solid rgb(112 112 112 / 20%);
      .complate-img{
        width: 160px;
        height: 32px;
        margin-right: 20px;
        cursor: pointer;
      }
      .userbox{
        display: flex;
        align-items: center;
        background: #F2F5F9;
        border-radius: 18px;
        padding-right: 12px;
        color: #707070;
        cursor: pointer;
        .avatar{
          position: relative;
          width: 36px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: #C5E1FB;
          .icon{
            color: #1890FF;
            font-size: 22px;
          }
          img{
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          .online{
            position: absolute;
            bottom: 0;
            right: 0;
            width: 13px;
            height: 13px;
            background: #19BE6B;
            border: 2px solid #FFFFFF;
            border-radius: 50%;
            box-sizing: border-box;
          }
          .busy{
            position: absolute;
            bottom: 0;
            right: 0;
            width: 13px;
            height: 13px;
            background: #f56c6c;
            border: 2px solid #FFFFFF;
            border-radius: 50%;
            box-sizing: border-box;
          }
          .offline{
            position: absolute;
            bottom: 0;
            right: 0;
            width: 13px;
            height: 13px;
            background: #E6A23C;
            border: 2px solid #FFFFFF;
            border-radius: 50%;
            box-sizing: border-box;
          }
        }
        .status{
          color: #707070;
          margin: 0 6px;
        }
        .user-name{
          margin: 0 10px;
        }
      }
    }

    .el-main{
      padding: 0;
    }
  }
  .user-info{
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #2A2A2A;
    .avatar{
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 18px;
      margin-right: 12px;
      .icon{
        color: #1890FF;
        font-size: 22px;
      }
      img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
  }
  .status-box{
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #2A2A2A;
    cursor: pointer;
    position: relative;
    padding-left: 10px;
    .status-online::before{
      content: '';
      position: absolute;
      top: 3px;
      left: -6px;
      width: 13px;
      height: 13px;
      background: #19BE6B;
      border: 2px solid #FFFFFF;
      border-radius: 50%;
      box-sizing: border-box;
    }
    .status-busy::before{
      content: '';
      position: absolute;
      top: 3px;
      left: -6px;
      width: 13px;
      height: 13px;
      background: #f56c6c;
      border: 2px solid #FFFFFF;
      border-radius: 50%;
      box-sizing: border-box;
    }
    .status-offline::before{
      content: '';
      position: absolute;
      top: 3px;
      left: -6px;
      width: 13px;
      height: 13px;
      background: #E6A23C;
      border: 2px solid #FFFFFF;
      border-radius: 50%;
      box-sizing: border-box;
    }
  }
  .popover-content{
    margin-top: 12px;
    font-size: 14px;
    color: #2A2A2A;
    .item{
      padding: 9px 12px;
      cursor: pointer;
    }
    .item:hover{
      background: rgba(24, 144, 255, 0.12);
      border-radius: 4px;
      color: #1890FF;
    }
  }
  .language-box{
    max-height: 300px;
    overflow: auto;
    .item{
      font-size: 12px;
      color: #2A2A2A;
      padding: 10px 20px;
      cursor: pointer;
    }
    .item:hover{
      padding: 10px 20px;
      background: rgba(24, 144, 255, 0.12);
      color: #1890FF;
    }
  }
  ::v-deep(.el-popover){
    padding: 0 !important;
  }
  // 不显示滚动条
  .language-box::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  .status-change{
    display: flex;
    flex-direction: column;
    .row{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 4px 0 0 10px;
      box-sizing: border-box;
      position: relative;
      cursor: pointer;
      .status-online::before{
        content: '';
        position: absolute;
        top: 9px;
        left: -6px;
        width: 10px;
        height: 10px;
        background: #19BE6B;
        border: 2px solid #FFFFFF;
        border-radius: 50%;
        box-sizing: border-box;
      }
      .status-busy::before{
        content: '';
        position: absolute;
        top: 9px;
        left: -6px;
        width: 10px;
        height: 10px;
        background: #f56c6c;
        border: 2px solid #FFFFFF;
        border-radius: 50%;
        box-sizing: border-box;
      }
      .status-offline::before{
        content: '';
        position: absolute;
        top: 9px;
        left: -6px;
        width: 10px;
        height: 10px;
        background: #E6A23C;
        border: 2px solid #FFFFFF;
        border-radius: 50%;
        box-sizing: border-box;
      }
    }
    .explain{
      padding: 8px 0 0;
      border-top: 1px solid rgb(112 112 112 / 20%);
      margin-top: 8px;
      text-align: center;
      cursor: pointer;
    }
  }
  .dialog-wrap{
    font-size: 12px;
    .row{
      margin-top: 12px;
      .title{
        font-weight: bold;
      }
    }
  }
  
  ::v-deep(.el-main){
    padding: 0;
  }
  ::v-deep(.el-menu){
    border-right: 0;
  }
  ::v-deep(.el-submenu .el-menu-item){
    min-width: auto;
    height: 32px;
    line-height: 32px;
  }
  ::v-deep(.el-menu-item), 
  ::v-deep(.el-submenu__title){
    height: 32px;
    line-height: 32px;
    margin: 6px 0;
    padding: 0 18px;
  }
  ::v-deep(.el-menu-item img),
  ::v-deep(.el-submenu__title img){
    margin-right: 14px;
  }
  ::v-deep(.el-menu-item){
    color: #2A2A2A;
  }
  ::v-deep(.el-menu-item.is-active){
    background: rgb(24 144 255 / 12%);
    border-radius: 4px;
  }
  ::v-deep(.el-submenu .el-menu){
    margin-left: 20px;
  }
  </style>
  